import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import ContextStates from '../context/ContextStates';
import { motion } from 'framer-motion';
import { Url } from './Url';
import { areaAnimateLR, areaAnimateRL, areaAnimateS } from './Animations';

const ResultSearch = () => {
    const { busqueda } = useContext(ContextStates)

    return (
        <div className='w-full'>
            <motion.div className={`w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4`}>
                {busqueda && busqueda.map((item, index) => (
                    <motion.div
                        key={index}
                        className='w-11/12 md:10/12 mx-auto shadow-2xl hover:shadow-3xl rounded-2xl'
                        initial={"offscreen"}
                        whileInView={"onscreen"}
                        viewport={{ once: true, amount: 0.1 }}
                        variants={areaAnimateS}
                        whileHover={{
                        }}
                    >
                        <Link className='w-full mx-2 shadow-2xl hover:shadow-3xl rounded-2xl' to={`/producto/${item.id}`}>
                            <div className='hover:cursor-pointer'>
                                <img className='w-full object-cover rounded-2xl' src={Url + item.imagenes[0].imagen} alt={item.descripcion} />
                                <h3 className='text-center text-xl mt-4 mb-2'>{item.descripcion}</h3>
                                <h3 className='text-center text-2xl mt-2 mb-2'>$ {parseFloat(item.precio).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</h3>
                            </div>
                        </Link>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    )
}

export default ResultSearch